export default __webpack_public_path__ + "static/media/Smart Heart Hamster Food.15c4b101.png";